namespace Solovis.Portal.FeaturedLinks {

    function _getPageReportViewControl(): any {
        let pageViewModel = (window as any).PageViewModel;

        if (pageViewModel && pageViewModel.isReportView) {
            var reportViewControl = pageViewModel.controlHost.currentControl;
            return reportViewControl;
        }
    }

    export function canUpdateFeaturedLink(): boolean {
        var reportViewControl = _getPageReportViewControl();
        if (reportViewControl && reportViewControl.featuredLinkCode && reportViewControl.featuredLinkEditableByCurrentUser) {
            return true;
        }

        return false;
    }

    export function updateFeaturedLink(): void {
        let pageViewModel = (window as any).PageViewModel;

        if (pageViewModel && pageViewModel.isReportView) {
            var updateLinkOptions: any = {};
            updateLinkOptions.reportOptionsJson = pageViewModel.getReportOptionsJson();
            if (updateLinkOptions.reportOptionsJson == null) {
                // No options, so just return without trying to create featured link.
                return;
            }

            var reportViewControl = pageViewModel.controlHost.currentControl;
            if (reportViewControl.featuredLinkCode && reportViewControl.featuredLinkEditableByCurrentUser) {
                updateLinkOptions.featuredLinkCode = reportViewControl.featuredLinkCode;
                var isSharedLink = reportViewControl.featuredLinkIsSharedLink;

                var title = isSharedLink ? "Update Shared Featured Link" : "Update Featured Link";
                var message = isSharedLink ? "Update existing shared featured link?" : "Update existing featured link?";

                Solovis.UI.confirm(message, title,
                    function (confirmed) {
                        if (confirmed) {
                            Solovis.Rpc.invokeAndWait(
                                "~/DataManagement/UserFeaturedLinks/UpdateFeaturedLink",
                                updateLinkOptions,
                                function (response, success) {
                                    if (success) {
                                        Solovis.UI.alert("Featured link updated.");
                                    }
                                });
                        }
                    });
            }
        }
    }


    export function showSavePageAsFeaturedLink(clickedElement?) {
        // Retrieve permission level for editing shared links, and then show dialog for adding a featured link.
        (Solovis as any).Reports.ReportDataLoader.loadDataSetAsync(
            "/Solovis/Security/CurrentUserSecurityCheck",
            {
                permissions: ["SharedLinkEdit"]
            },
            function (response, success) {
                if (success) {
                    var dataSet = response.result.dataSet;

                    var canEditSharedLink = false;
                    if (dataSet && dataSet.permissions && dataSet.permissions.length > 0 && dataSet.permissions[0].name == 'SharedLinkEdit') {
                        canEditSharedLink = dataSet.permissions[0].allowed;
                    }

                    FeaturedLinks._internalShowSavePageAsFeaturedLink(clickedElement, canEditSharedLink);
                }
            },
            {
                invokeMethod: "invokeAndWait"
            });
    }

    export function _internalShowSavePageAsFeaturedLink(clickedElement, canEditSharedLink: boolean) {
        let pageViewModel = (window as any).PageViewModel;

        var pathname = window.location.pathname;
        var siteRoot = (Solovis as any).Info.siteRoot;

        if (pathname.length >= siteRoot.length) {
            if (pathname.substr(0, siteRoot.length) == siteRoot) {
                // pathname starts with siteRoot, so remove siteRoot and prefix with "~/".
                pathname = "~/" + pathname.substr(siteRoot.length);
            }
        }

        var title = document.title;

        var addLinkOptions: any = {
            name: title
        };

        if (pageViewModel && pageViewModel.isReportView) {
            addLinkOptions.reportOptionsJson = pageViewModel.getReportOptionsJson();
            if (addLinkOptions.reportOptionsJson == null) {
                // No options, so just return without trying to create featured link.
                return;
            }
        }
        else {
            var url = pathname + window.location.search + window.location.hash;
            addLinkOptions.url = url;
        }

        // Allow user to edit title.

        var formBuilderDiv = $("<div>");
        var formBuilder = new Solovis.UI.InputControls.FormBuilder({
            container: formBuilderDiv
        });

        formBuilder.addEntry({
            name: "name",
            label: "Name",

            initialValue: title,

            editor: {
                type: "text",
                required: true
            }
        });

        formBuilder.addEntry({
            name: "category",
            label: "Category",

            initialValue: null,

            editor: {
                type: "text"
            }
        });

        formBuilder.addEntry({
            name: "addAsSharedLink",
            label: "Add As Shared Link",

            initialValue: false,

            editor: {
                type: "bool"
            }
        });

        formBuilder.setupDone();

        if (!canEditSharedLink) {
            formBuilder.getEntryByName("addAsSharedLink").showEntry(false);
        }

        let dialog = formBuilder.showAsDialog({
            title: "Add Featured Link",
            modal: true,
            desiredWidth: 650,
            desiredHeight: 250,

            showSaveCancel: true,
            saveCallback: () => {
                if (!formBuilder.hasErrors()) {
                    var name = formBuilder.getValueByName("name").trim();
                    var category = formBuilder.getValueByName("category").trim();
                    var sharedLink = formBuilder.getValueByName("addAsSharedLink");

                    addLinkOptions.name = name;
                    addLinkOptions.category = category;
                    addLinkOptions.sharedLink = sharedLink;

                    Solovis.Rpc.invokeAndWait(
                        "~/DataManagement/UserFeaturedLinks/AddFeaturedLink",
                        addLinkOptions,
                        function (response, success) {
                            if (success) {
                                dialog.close();

                                let featuredLinkCode = response.result.code;
                                let reportViewControl = _getPageReportViewControl();
                                if (reportViewControl && reportViewControl.setCurrentFeaturedLinkCode) {
                                    reportViewControl.setCurrentFeaturedLinkCode(featuredLinkCode);
                                }

                                Solovis.UI.alert("Featured link saved.");
                            }
                        });
                }
                return false;
            }
        });

    }


    export function showFeaturedLinksInDialog() {
        var dialogDiv = $("<div>");

        var linksReportDiv = $("<div>").appendTo(dialogDiv);

        var featuredLinksReportCode = "01619685-6086-4780-8A9F-BBE72AF3FFC4";

        // NOTE: Solovis.Reports is not defined in this module or its dependencies.
        var linksReport = new (Solovis as any).Reports.ReportControl({
            controlHost: linksReportDiv,
            reportCode: featuredLinksReportCode,
            hideConfigSection: true
        });
        linksReport.setAsCurrentControl();

        var dialog = new Solovis.UI.Dialog({
            container: dialogDiv,

            title: "Featured Links",
            center: true,
            width: 500,
            height: 400,
            autoOpen: true,
            modal: true,
            destroyOnClose: true,
            actions: ["Close"]
        });
    }

    export function showShareFeaturedLink() {
        let pageViewModel = (window as any).PageViewModel;

        var pathname = window.location.pathname;
        var siteRoot = (Solovis as any).Info.siteRoot;

        if (pathname.length >= siteRoot.length) {
            if (pathname.substr(0, siteRoot.length) == siteRoot) {
                // pathname starts with siteRoot, so remove siteRoot and prefix with "~/".
                pathname = "~/" + pathname.substr(siteRoot.length);
            }
        }

        var title = document.title;

        var addLinkOptions: any = {
            name: title
        };

        if (pageViewModel && pageViewModel.isReportView) {
            addLinkOptions.reportOptionsJson = pageViewModel.getReportOptionsJson();
            if (addLinkOptions.reportOptionsJson == null) {
                // No options, so just return without trying to create featured link.
                return;
            }
        }
        else {
            var url = pathname + window.location.search + window.location.hash;
            addLinkOptions.url = url;
        }

        // Allow user to edit title.

        var formBuilderDiv = $("<div>");
        var formBuilder = new Solovis.UI.InputControls.FormBuilder({
            container: formBuilderDiv
        });

        formBuilder.addEntry({
            name: "name",
            label: "Name",

            initialValue: title,

            editor: {
                type: "text",
                required: true
            }
        });

        formBuilder.addEntry({
            name: "category",
            label: "Category",

            initialValue: null,

            editor: {
                type: "text"
            }
        });

        formBuilder.setupDone();

        let dialog = formBuilder.showAsDialog({
            title: "Share Report",
            modal: true,
            desiredWidth: 650,
            desiredHeight: 250,

            showSaveCancel: true,
            saveButtonText: "Share",
            saveCallback: () => {
                if (!formBuilder.hasErrors()) {
                    var name = formBuilder.getValueByName("name");
                    var category = formBuilder.getValueByName("category");
                    var sharedLink = true;

                    addLinkOptions.name = name;
                    addLinkOptions.category = category;
                    addLinkOptions.sharedLink = sharedLink;

                    Solovis.Rpc.invokeAndWait(
                        "~/DataManagement/UserFeaturedLinks/AddFeaturedLink",
                        addLinkOptions,
                        function (response, success) {
                            if (success) {
                                dialog.close();

                                let featuredLinkCode = response.result.code;
                                let reportViewControl = _getPageReportViewControl();
                                if (reportViewControl && reportViewControl.setCurrentFeaturedLinkCode) {
                                    reportViewControl.setCurrentFeaturedLinkCode(featuredLinkCode);
                                }

                                Solovis.UI.alert("You have shared the report", "Success");
                            }
                        });
                }
                return false;
            }
        });
    }

    export function showSaveReport(saveAsSelf: boolean) {
        let pageViewModel = (window as any).PageViewModel;

        var pathname = window.location.pathname;
        var siteRoot = (Solovis as any).Info.siteRoot;

        if (pathname.length >= siteRoot.length) {
            if (pathname.substr(0, siteRoot.length) == siteRoot) {
                // pathname starts with siteRoot, so remove siteRoot and prefix with "~/".
                pathname = "~/" + pathname.substr(siteRoot.length);
            }
        }

        var title = document.title;

        var saveReportOptions: any = {
            name: title,
            userSpecific: saveAsSelf,
            description: "",
            readOnly: false,
            addFavorite: false,
        };

        if (pageViewModel && pageViewModel.reportPath) {
            saveReportOptions.sourcePath = pageViewModel.reportPath;
        }
        if (pageViewModel && pageViewModel.reportCode) {
            saveReportOptions.sourceCode = pageViewModel.reportCode;
        }
        if (pageViewModel && pageViewModel.reportAlias) {
            saveReportOptions.sourceAlias = pageViewModel.reportAlias;
        }

        var formBuilderDiv = $("<div>");
        var formBuilder = new Solovis.UI.InputControls.FormBuilder({
            container: formBuilderDiv
        });

        formBuilder.addEntry({
            name: "name",
            label: "Name",

            initialValue: title,

            editor: {
                type: "text",
                required: true
            }
        });

        formBuilder.addEntry({
            name: "category",
            label: "Category",

            initialValue: null,

            editor: {
                type: "text"
            }
        });

        formBuilder.setupDone();

        let dialog = formBuilder.showAsDialog({
            title: saveAsSelf ? "Save As (self)" : "Save As (everyone)",
            modal: true,
            desiredWidth: 650,
            desiredHeight: 250,

            showSaveCancel: true,
            saveCallback: () => {
                if (!formBuilder.hasErrors()) {
                    var name = formBuilder.getValueByName("name");
                    var category = formBuilder.getValueByName("category");

                    saveReportOptions.targetPath = `${category}/${name}`;

                    Solovis.Rpc.invokeAndWait(
                        "~/ReportEdit/SaveNewReport",
                        saveReportOptions,
                        function (response, success) {
                            if (success) {
                                dialog.close();
                                if (saveAsSelf) {
                                    Solovis.UI.alert("Your report has been saved.");
                                }
                                else {
                                    Solovis.UI.alert("Your report has been saved for everyone.");
                                }
                            }
                        });
                }
                return false;
            }
        });
    }
    export function SaveReportSettingAsFeatureLink(jsonSettings: string, reportCode: string, reportAlias: string) {
        const saveReportSettingsOptions: any = {
            reportCode: reportCode,
            reportAlias: reportAlias,
            reportOptionsJson: jsonSettings
        };

        Solovis.Rpc.invokeAndWait(
            "~/ReportEdit/SaveReportSettingAsFeatureLink",
            saveReportSettingsOptions,
            function (response, success) {
                if (success) {
                    Solovis.UI.alert("Your settings have been saved.");
                }
            });
    }

    export function showSavePageAsFavorite(clickedElement?) {
        let pageViewModel = (window as any).PageViewModel;

        var pathname = window.location.pathname;
        var siteRoot = (Solovis as any).Info.siteRoot;

        if (pathname.length >= siteRoot.length) {
            if (pathname.substr(0, siteRoot.length) == siteRoot) {
                // pathname starts with siteRoot, so remove siteRoot and prefix with "~/".
                pathname = "~/" + pathname.substr(siteRoot.length);
            }
        }

        var title = document.title;

        var addLinkOptions: any = {
            name: title
        };

        if (pageViewModel && pageViewModel.isReportView) {
            addLinkOptions.reportOptionsJson = pageViewModel.getReportOptionsJson();
            if (addLinkOptions.reportOptionsJson == null) {
                // No options, so just return without trying to create featured link.
                return;
            }
        }
        else {
            var url = pathname + window.location.search + window.location.hash;
            addLinkOptions.url = url;
        }

        // Allow user to edit title.

        var formBuilderDiv = $("<div>");
        var formBuilder = new Solovis.UI.InputControls.FormBuilder({
            container: formBuilderDiv
        });

        formBuilder.addEntry({
            name: "name",
            label: "Name",

            initialValue: title,

            editor: {
                type: "text",
                required: true
            }
        });

        formBuilder.addEntry({
            name: "category",
            label: "Category",

            initialValue: null,

            editor: {
                type: "text"
            }
        });

        formBuilder.setupDone();

        let dialog = formBuilder.showAsDialog({
            title: "Favorite Report",
            modal: true,
            desiredWidth: 650,
            desiredHeight: 250,

            showSaveCancel: true,
            saveCallback: () => {
                if (!formBuilder.hasErrors()) {
                    var name = formBuilder.getValueByName("name");
                    var category = formBuilder.getValueByName("category");

                    addLinkOptions.name = name;
                    addLinkOptions.category = category;
                    addLinkOptions.sharedLink = false;

                    Solovis.Rpc.invokeAndWait(
                        "~/DataManagement/UserFeaturedLinks/AddFeaturedLink",
                        addLinkOptions,
                        function (response, success) {
                            if (success) {
                                dialog.close();

                                let featuredLinkCode = response.result.code;
                                let reportViewControl = _getPageReportViewControl();
                                if (reportViewControl && reportViewControl.setCurrentFeaturedLinkCode) {
                                    reportViewControl.setCurrentFeaturedLinkCode(featuredLinkCode);
                                }

                                Solovis.UI.alert("Featured link saved.");
                            }
                        });
                }
                return false;
            }
        });
    }
}


